import { render } from "./AgenteTicketComponent.vue?vue&type=template&id=2abdc52c"
import script from "./AgenteTicketComponent.vue?vue&type=script&lang=js"
export * from "./AgenteTicketComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/daniel/Documents/CETECREA/cetecrea/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__